import { NgModule } from '@angular/core';

import { CountryStateService } from './country-state.service';

@NgModule({
  imports: [],
  providers: [CountryStateService],
  declarations: [],
  exports: [],
})
export class CountryStateServiceModule {}
